module.exports = __webpack_public_path__ + "fonts/payback_light-webfont.0bf6b4fa.eot";